<template>
  <TaxonomyTermSelect :termId="termId" :multiple="multiple" :slug="slug" @on-changed="handleTermDataChanged">
  </TaxonomyTermSelect>
</template>

<script>
/**
 * The difference between TaxonomyTermSelect component is the wrapper of data sync to upper level
 * component.
 */
import TaxonomyTermSelect from '@/view/taxonomy/components/taxonomy-term-select'
export default {
  name: 'TaxonomyTermSelectField',
  components: {
    TaxonomyTermSelect
  },
  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    slug: {
      type: String,
      required: true
    },
    value: {
      type: [Object, Array, Number],
      required: false
    }
  },
  computed: {
    termId: function () {
      // When multiple
      if (this.multiple) {
        return _.map(this.value, item => {
          if (item instanceof Object) {
            return item.id
          }
          return item
        })
      }

      // When single value
      if (Array.isArray(this.value)) {
        return _.first(this.value).id
      } else if (this.value instanceof Object) {
        return this.value.id
      }

      return this.value
    }
  },
  methods: {
    handleTermDataChanged: function (data) {
      if (!this.multiple) {
        this.$emit('update:data', [data])
      } else {
        this.$emit('update:data', data)
      }
    }
  }
}
</script>
